import { Component, OnInit, ViewChild, Output,EventEmitter } from '@angular/core';

import { Topic } from 'app/models/topic';
import { File } from 'app/models/file';
import { TopicService } from 'app/services/topic.service';
import { CompetitionService } from 'app/services/competition.service';
import { ModalPanelComponent } from 'app/shared/components/modal-panel/modal-panel.component';

@Component({
  selector: 'app-modal-topic',
  templateUrl: './modal-topic.component.html',
  styleUrls: ['./modal-topic.component.scss']
})
export class ModalTopicComponent implements OnInit {
  @ViewChild('modalPanel') modalPanel: ModalPanelComponent;
  @ViewChild('topicForm') topicForm: any;
  topic: Topic;
  title: string;
  buttonTitle: string;
  @Output()
  close= new EventEmitter();
  constructor(private topicService: TopicService, private competitionService: CompetitionService) {
    this.topic = new Topic(null, competitionService.getCompetitionId(),
                           null, null, null, null, null, null, new Array<File>());
  }

  ngOnInit() {
  }

  onSave() {
    if (this.topic.id) {
      this.topicService.update(this.topic)
      .subscribe(res => this.modalPanel.onClose());
    } else {
      this.topicService.create(this.topic)
      .subscribe(res => this.modalPanel.onClose());
    }
    this.close.emit();
  }
  
  
}
